import { LoggedUserStore } from "../../modules/signin/userStore";

export const signOut = () => {
  const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('umid');
    LoggedUserStore.signOutUser(); 
    window.location.href = currentUrl.pathname + currentUrl.search;
}
